<template>
  <div>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="formData.code"
            name="code"
            label="单据号"
          >
          </van-field>
        </van-cell>
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.scId"
            name="scId"
            label="仓库"
          >
          </van-field>
        </van-cell> -->
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.supplierId"
            name="supplierId"
            label="会员名称"
          >
          </van-field>
        </van-cell> -->
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.createBy"
            name="createBy"
            label="操作人"
          >
          </van-field>
        </van-cell> -->
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="formData.createStartTime"
            name="createStartTime"
            inputmode="none"
            label="操作日期"
            readonly
            @click="openDatePicker('createStartTime')"
          >
          </van-field>
          <van-field
            autocomplete="off"
            v-model="formData.createEndTime"
            name="createEndTime"
            label="至"
            readonly
            @click="openDatePicker('createEndTime')"
          >
          </van-field>
        </van-cell>
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.approveBy"
            name="approveBy"
            label="审核人"
          >
          </van-field>
        </van-cell> -->
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.approveStartTime"
            name="approveStartTime"
            label="审核日期"
            readonly
            @click="openDatePicker('approveStartTime')"
          >
          </van-field>
          <van-field
           autocomplete="off"
            v-model="formData.approveEndTime"
            name="approveEndTime"
            label="至"
            readonly
            @click="openDatePicker('approveEndTime')"
          >
          </van-field>
        </van-cell> -->
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="formData.purchaser"
            name="purchaser"
            label="采购员"
          >
          </van-field>
        </van-cell> -->
        <van-cell @click="showStatusPicker = true">
          <van-field
            autocomplete="off"
            v-model="formData.statusText"
            label="状态"
            inputmode="none"
            clearable
          ></van-field>
        </van-cell>
        <van-popup
          close-on-click-overlay
          v-model:show="showStatusPicker"
          round
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="statusColumns"
            @cancel="showStatusPicker = false"
            @confirm="onStatusSelectConfirm"
          />
        </van-popup>
        <van-cell>
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            :loading="loading"
            loading-text="查询中..."
          >
            查询
          </van-button>
        </van-cell>
      </van-cell-group>

      <DateTimePicker
        :showPicker="showDatePicker"
        @confirm="onConfirm"
        @cancel="showDatePicker = false"
      ></DateTimePicker>
    </van-form>
    <div style="margin: 16px 0">
      <div class="action">
        <Van-icon
          v-permission="'retail:out:add'"
          name="add-o"
          type="primary"
          @click="$router.push('/retail/outAdd')"
        ></Van-icon>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已显示全部"
        ref="scrollContainer"
        @load="getList(true)"
      >
        <div
          v-for="item in tableData"
          :key="item.id"
          class="container"
          @click="rowClick(item)"
        >
          <div class="title">采购单号:{{ item.code }}</div>
          <div class="content">
            <div class="left">
              <div class="item flex" v-for="el in columns" :key="el.key">
                <div class="label">{{ el.title }}</div>
                <div class="value">{{ item[el.key] }}</div>
              </div>
            </div>

            <div class="">
              <div
                :class="[
                  {
                    color1: item.status == '0',
                    color2: item.status == '6',
                    color3: item.status == '3',
                  },
                  'status',
                ]"
              >
                {{ getText(item.status) }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { query } from "../../../service/api/retail/out";
import CustomTable from "../../../components/customTable.vue";
import {
  PURCHASE_ORDER_STATUS,
  getTextByValue,
} from "../../../utils/constants";
import DateTimePicker from "../../../components/dateTimePicker";
import { oneMonthAgoMidnight } from "../../../utils";
export default {
  name: "index",
  components: {
    CustomTable,
    DateTimePicker,
  },
  data() {
    return {
      finished: false,
      loading: false,
      showStatusPicker: false,
      action: [
        { name: "审核通过", click: "" },
        { name: "审核拒绝", click: "" },
      ],
      showActions: false,
      columns: [
        {
          field: "code",
          width: 100,
          title: "单据号",
          key: "code",
          fixed: "left",
        },
        { field: "scCode", title: "仓库编号", width: 100, key: "scCode" },
        { field: "scName", width: 100, title: "仓库名称", key: "scName" },
        {
          field: "purchaseAmount",
          width: 60,
          title: "采购总金额",
          key: "purchaseAmount",
        },
        {
          field: "totalAmount",
          width: 60,
          title: "单据总金额",
          key: "totalAmount",
        },
        {
          field: "grossMargin",
          key: "grossMargin",
          title: "毛利率",
          width: 100,
        },
        {
          field: "totalNum",
          width: 60,
          title: "商品数量",
          key: "totalNum",
        },
        {
          field: "totalGiftNum",
          width: 60,
          title: "赠品数量",
          key: "totalGiftNum",
        },

        {
          field: "createTime",
          width: 100,
          title: "操作时间",
          key: "createTime",
        },
        {
          field: "memberName",
          width: 100,
          title: "会员名称",
          key: "memberName",
        },
        { field: "salerName", key: "salerName", title: "销售员", width: 50 },

        // {field:'createBy, width:100', title: "操作人", key: "createBy" },
        {
          field: "status",
          width: 60,
          title: "状态",
          fixed: "right",
          key: "status",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusClass =
              row.status == "0"
                ? "color1"
                : row.status == "6"
                ? "color2"
                : "color3";
            return (
              <div class={statusClass}>
                {getTextByValue(PURCHASE_ORDER_STATUS, row.status)}
              </div>
            );
          },
        },
        // {
        //   field: "",
        //   key: "e",
        //   title: "操作",
        //   width: "",
        //   fixed: "right",
        //   renderBodyCell: ({ row, column, rowIndex }, h) => {
        //     return (
        //       <span>
        //         <van-icon
        //           name="setting-o"
        //           on-click={(e) => this.showSettingPopup(e)}
        //         ></van-icon>
        //       </span>
        //     );
        //   },
        // },
      ],
      tableData: [],
      currentDate: "",
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      formData: {},
      key: "",
      showDatePicker: false,
    };
  },
  computed: {
    statusColumns() {
      return PURCHASE_ORDER_STATUS;
    },
  },
  created() {
    this.formData.createStartTime = oneMonthAgoMidnight();
    this.formData.createEndTime = moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.onSubmit();
  },
  methods: {
    getText(status) {
      return getTextByValue(PURCHASE_ORDER_STATUS, status);
    },
    onSubmit() {
      this.pageIndex = 1;
      this.getList();
    },
    onStatusSelectConfirm(val) {
      this.formData.status = val.value;
      this.formData.statusText = val.text;
      this.showStatusPicker = false;
    },
    showSettingPopup(e) {
      e.stopPropagation();
      this.showActions = true;
    },
    rowClick(item) {
      //进入详情页
      this.$router.push({
        path: "/retail/outDetail/" + item.id,
      });
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;

      this.getList();
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    openDatePicker(key) {
      this.showDatePicker = true;
      this.key = key;
    },
    onConfirm(value) {
      this.formData[this.key] = value;
      this.showDatePicker = false;
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = false;
      this.finished = false;
      this.loading = true;
      const params = {
        ...this.formData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      query(params)
        .then((res) => {
          this.loading = false;
          if (load) {
            this.tableData = this.tableData.concat(res.data.datas);
          } else {
            this.tableData = res.data.datas;
          }
          this.totalCount = res.data.totalCount;
          this.totalPage = res.data.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
        });
      //
      // let params = {};
      // for (const key in this.formData) {
      //   if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
      //     const value = this.formData[key] === "是" ? true : false;
      //     params[key] = value;
      //   }
      // }
      // update(params).then((res) => {
      //
      // });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 8px !important;
}
::v-deep .color1 {
  color: #333;
}
::v-deep .color2 {
  color: #ee0a24;
}
::v-deep .color3 {
  color: #07c160;
}

.container {
  margin-top: 5px;
  padding: 10px 0 10px 10px;
  background-color: #fff;
  .title {
    font-size: 15px;
    font-weight: 500;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    .left {
      flex: 5;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .label {
          font-size: 14px;
          color: #333;
        }
        .value {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .status {
      width: 90px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }
    .color1 {
      background: linear-gradient(83deg, #333, #858585);
    }
    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
    .color3 {
      background: linear-gradient(83deg, #4c9673, #98bf8c);
    }
  }
}
::v-deep .van-list {
  height: calc(100vh - 7rem);
  overflow: auto;
}
</style>
